// extracted by mini-css-extract-plugin
export default {"Header":"ProductDetails_Header__j0nSY","Paragraf":"ProductDetails_Paragraf__yUdYA","ProductDetailsHeaderWrapper":"ProductDetails_ProductDetailsHeaderWrapper__alH5s"};